module.exports = __webpack_public_path__ + "static/media/newsroom_icon.407ce962.svg";